"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var queryString = __importStar(require("query-string"));
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var modal_1 = __importDefault(require("../../../../plugins/modal"));
var format_bundle_variant_title_1 = __importDefault(require("../../../../utils/format-bundle-variant-title"));
var format_price_1 = __importDefault(require("../../../../utils/format-price"));
var api_1 = require("../../../returns/api");
var bundle_components_1 = __importDefault(require("../../bundle-components"));
var inline_loader_1 = __importDefault(require("../../components/inline_loader"));
var redeem_retention_offer_1 = require("../../mutations/redeem-retention-offer");
var get_retention_offer_1 = require("../../queries/get-retention-offer");
var convertRetentionOfferBundleTypeToBundleComponentsBundleType = function (type) {
    switch (type) {
        case 'DIAPER_BUNDLE':
            return 'Diaper';
        case 'ESSENTIALS_BUNDLE':
            return 'Fundamentals';
        case 'OTP':
            throw new Error('Unsupported retention offer bundle type OTP');
        case 'TRAINING_PANTS_BUNDLE':
            return 'Training Pant';
        case 'VITAMIN_BUNDLE':
            return 'Vitamin';
    }
};
/**
 * If the offer is subscribing to the variant, use the shopify price.
 * Otherwise use the custom price (configured in the retention offer), defaulting to zero (freebies).
 */
var determinePrice = function (retentionOffer, variant) {
    return (retentionOffer === null || retentionOffer === void 0 ? void 0 : retentionOffer.willSubscribeVariants) ? Number(variant.variant.price) : variant.price || 0;
};
var RetentionOfferV2 = function (_a) {
    var _b, _c, _d, _e, _f;
    var groupedSubscriptions = _a.groupedSubscriptions;
    // parse the offer from the url
    var q = queryString.parse(window.location.search);
    // if slug comes from url, always show the offer and do nothing with cookies
    // if slug comes from CMS and the browser doesn't already have a cookie for this offer, show the offer and get ready to set the cookie
    var _g = (function () {
        var _a;
        if (q.offer) {
            return { slug: q.offer, cookieKeyToSet: undefined };
        }
        else {
            var cmsSlug = (_a = window.accountApp.settings.campaign) === null || _a === void 0 ? void 0 : _a.retentionOfferSlug;
            if (cmsSlug) {
                var COOKIE_PREFIX = 'retentionOfferV2Shown';
                var key = "".concat(COOKIE_PREFIX, "|").concat(cmsSlug);
                var cookie = js_cookie_1.default.get(key);
                if (!cookie)
                    return { slug: cmsSlug, cookieKeyToSet: key };
            }
        }
        return { slug: undefined, cookieKeyToSet: undefined };
    })(), slug = _g.slug, cookieKeyToSet = _g.cookieKeyToSet;
    // fetch the retention offer
    var _h = (0, react_query_1.useQuery)(['GetRetentionOffer', slug], function () { return api_1.graphQLClient.request(get_retention_offer_1.QUERY, { slug: slug }); }, { enabled: !!slug }), getRetentionOffer = _h.data, isLoadingRetentionOffer = _h.isLoading;
    // choose the subscription from the customer's subscriptions that the offer would get applied to
    var bundleTypes = (_b = getRetentionOffer === null || getRetentionOffer === void 0 ? void 0 : getRetentionOffer.retentionOffer) === null || _b === void 0 ? void 0 : _b.bundleTypes.map(convertRetentionOfferBundleTypeToBundleComponentsBundleType);
    var chosenSubscription = (function () {
        if (q.bundleId) {
            return groupedSubscriptions === null || groupedSubscriptions === void 0 ? void 0 : groupedSubscriptions.find(function (subscription) { return subscription.subscription.properties.some(function (p) { return p.name === 'bundle_id' && p.value === q.bundleId; }); });
        }
        else {
            var firstMatchingSubscription = groupedSubscriptions === null || groupedSubscriptions === void 0 ? void 0 : groupedSubscriptions.find(function (subscription) {
                var bundleComponents = new bundle_components_1.default(subscription);
                var subscriptionBundleType = bundleComponents.getBundleType();
                if (bundleTypes === null || bundleTypes === void 0 ? void 0 : bundleTypes.includes(subscriptionBundleType))
                    return true;
            });
            return firstMatchingSubscription;
        }
    })();
    var _j = __read((0, react_1.useState)(false), 2), wasRedeemed = _j[0], setWasRedeemed = _j[1];
    var _k = __read((0, react_1.useState)(false), 2), shouldSelectVariants = _k[0], setShouldSelectVariants = _k[1];
    var _l = __read((0, react_1.useState)([]), 2), selectedVariants = _l[0], setSelectedVariants = _l[1];
    var _m = __read((0, react_1.useState)(false), 2), hasSelectedEnoughVariants = _m[0], setHasSelectedEnoughVariants = _m[1];
    var discountImage = window.accountApp.settings.retention.discountImage;
    // set up the redemption mutation
    var _o = (0, react_query_1.useMutation)("redeemRetentionOffer", function (variables) {
        return api_1.graphQLClient.request(redeem_retention_offer_1.MUTATION, variables);
    }), redeemRetentionOffer = _o.mutateAsync, isRedeeming = _o.isLoading, redemptionError = _o.error;
    var _p = __read((0, react_1.useState)(!isLoadingRetentionOffer), 2), isModalOpen = _p[0], setIsModalOpen = _p[1];
    // bundleIdentifier is a bundleId if this is a hellobello bundle and a subscription id if this is a recharge bundle
    var _q = (function () {
        var _a;
        if (!chosenSubscription)
            return { bundleIdentifier: undefined, bundleManager: undefined };
        if (chosenSubscription.manager === 'hellobello') {
            return {
                bundleIdentifier: (_a = chosenSubscription.subscription.properties.find(function (p) { return p.name === 'bundle_id'; })) === null || _a === void 0 ? void 0 : _a.value,
                bundleManager: chosenSubscription.manager,
            };
        }
        else {
            return {
                bundleIdentifier: "".concat(chosenSubscription.subscription.id),
                bundleManager: chosenSubscription.manager,
            };
        }
    })(), bundleIdentifier = _q.bundleIdentifier, bundleManager = _q.bundleManager;
    var selectedBundleType = chosenSubscription ? new bundle_components_1.default(chosenSubscription).getBundleType() : undefined;
    var offerType = (_c = getRetentionOffer === null || getRetentionOffer === void 0 ? void 0 : getRetentionOffer.retentionOffer) === null || _c === void 0 ? void 0 : _c.offerType;
    var redeemedVariants = (function () {
        var _a;
        switch (offerType) {
            case 'AUTO_VARIANTS':
                return ((_a = getRetentionOffer === null || getRetentionOffer === void 0 ? void 0 : getRetentionOffer.retentionOffer) === null || _a === void 0 ? void 0 : _a.variants) || [];
            case 'SELECT_VARIANTS':
                return selectedVariants;
            default:
                return [];
        }
    })();
    var handleRedeem = (0, react_1.useCallback)(function (variantIds) { return __awaiter(void 0, void 0, void 0, function () {
        var summedPriceOfVariants, redeemedVariants_1, redeemedVariants_1_1, variant;
        var e_1, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!bundleIdentifier)
                        throw new Error('bundleIdentifier is not defined'); // the ui should have prevented this
                    if (!slug)
                        throw new Error('slug is not defined'); // the ui should have prevented this
                    // the mutation will handle loading and errors
                    return [4 /*yield*/, redeemRetentionOffer({ slug: slug, bundleId: bundleIdentifier, manager: bundleManager, variantIds: variantIds })];
                case 1:
                    // the mutation will handle loading and errors
                    _c.sent();
                    summedPriceOfVariants = 0;
                    try {
                        for (redeemedVariants_1 = __values(redeemedVariants), redeemedVariants_1_1 = redeemedVariants_1.next(); !redeemedVariants_1_1.done; redeemedVariants_1_1 = redeemedVariants_1.next()) {
                            variant = redeemedVariants_1_1.value;
                            summedPriceOfVariants += determinePrice(getRetentionOffer === null || getRetentionOffer === void 0 ? void 0 : getRetentionOffer.retentionOffer, variant);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (redeemedVariants_1_1 && !redeemedVariants_1_1.done && (_a = redeemedVariants_1.return)) _a.call(redeemedVariants_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    (_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.push({ event: 'retentionOffer__variantsAdded', campaignId: slug, bundleType: selectedBundleType, summedPriceOfVariants: summedPriceOfVariants });
                    setWasRedeemed(true);
                    setShouldSelectVariants(false);
                    return [2 /*return*/];
            }
        });
    }); }, [bundleIdentifier, bundleManager, redeemRetentionOffer, slug, selectedBundleType, redeemedVariants, getRetentionOffer === null || getRetentionOffer === void 0 ? void 0 : getRetentionOffer.retentionOffer]);
    var hasOpenedModal = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        // after the first (and only) time the retention offer is loaded
        // 1) show the modal, and 2) begin redeeming any auto offers
        var _a, _b;
        if (hasOpenedModal.current)
            return;
        if (!(getRetentionOffer === null || getRetentionOffer === void 0 ? void 0 : getRetentionOffer.retentionOffer) || !bundleIdentifier)
            return;
        if (isLoadingRetentionOffer)
            return;
        setIsModalOpen(true);
        hasOpenedModal.current = true;
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'retentionOffer__campaignShown', campaignId: slug, bundleType: selectedBundleType });
        if (offerType === 'FIXED_DISCOUNT' || offerType === 'PERCENTAGE_DISCOUNT') {
            handleRedeem().catch(console.error);
        }
        else if (offerType === 'AUTO_VARIANTS') {
            handleRedeem((_b = getRetentionOffer === null || getRetentionOffer === void 0 ? void 0 : getRetentionOffer.retentionOffer) === null || _b === void 0 ? void 0 : _b.variants.map(function (v) { return v.variant.id; })).catch(console.error);
        }
        else if (offerType === 'SELECT_VARIANTS') {
            setShouldSelectVariants(true);
        }
    }, [getRetentionOffer === null || getRetentionOffer === void 0 ? void 0 : getRetentionOffer.retentionOffer, bundleIdentifier, isLoadingRetentionOffer, offerType, handleRedeem, slug, selectedBundleType]);
    var handleClose = function () {
        setIsModalOpen(false);
        if (cookieKeyToSet)
            js_cookie_1.default.set(cookieKeyToSet, '1', { expires: 7 });
        // we basically just hope here that the browser sets the cookie before navigating
        window.location.href = '/account';
    };
    var handleSelectVariant = function (variant) { return function () {
        if (!(getRetentionOffer === null || getRetentionOffer === void 0 ? void 0 : getRetentionOffer.retentionOffer))
            return;
        var existingIdx = selectedVariants.findIndex(function (v) { return v.variant.id === variant.variant.id; });
        var newSelections = selectedVariants.slice(0);
        var maxNumSelections = getRetentionOffer.retentionOffer.maxNumVariantsToSelect || getRetentionOffer.retentionOffer.variants.length;
        var minNumSelections = getRetentionOffer.retentionOffer.minNumVariantsToSelect || 1;
        // add or remove the variant
        if (existingIdx !== -1)
            newSelections.splice(existingIdx);
        else
            newSelections.push(variant);
        // make sure to keep only the newest selections
        var numOldSelectionsToRemove = newSelections.length - maxNumSelections;
        if (numOldSelectionsToRemove > 0)
            newSelections.splice(0, numOldSelectionsToRemove);
        setSelectedVariants(function () { return newSelections; });
        setHasSelectedEnoughVariants(newSelections.length >= minNumSelections);
    }; };
    // if no offer was found, or we haven't yet finished fetching the offer, or if the customer doesn't have an applicable bundle, stop here
    if (!(getRetentionOffer === null || getRetentionOffer === void 0 ? void 0 : getRetentionOffer.retentionOffer) || !bundleIdentifier)
        return null;
    if (((_d = chosenSubscription === null || chosenSubscription === void 0 ? void 0 : chosenSubscription.address) === null || _d === void 0 ? void 0 : _d.country) === 'Canada') {
        return null;
    }
    return (react_1.default.createElement(modal_1.default, { isOpen: isModalOpen, handleClose: handleClose, closeClassNames: 'ss-delete text-white', style: { overlay: { backgroundColor: 'rgba(0, 0, 0, 0.75)' } } },
        react_1.default.createElement("div", { className: 'retention-integration', style: { backgroundColor: '#f5f5f7', maxWidth: 500 } },
            isRedeeming && (offerType === 'FIXED_DISCOUNT' || offerType === 'PERCENTAGE_DISCOUNT' || offerType === 'AUTO_VARIANTS') && (react_1.default.createElement(inline_loader_1.default, { isLoading: true, loadingText: 'Redeeming...' })),
            redemptionError && (react_1.default.createElement("div", { className: 'padding-4 text-center' },
                react_1.default.createElement("div", { className: 'font-bold padding-bottom-4' }, "There was an error. Please contact Customer Support."),
                react_1.default.createElement("pre", null, (_f = (_e = redemptionError.response) === null || _e === void 0 ? void 0 : _e.errors) === null || _f === void 0 ? void 0 : _f.map(function (e) { return e.message; }).join(', ')))),
            wasRedeemed && !redemptionError && (react_1.default.createElement("div", { className: 'selectFreebie' },
                react_1.default.createElement("div", { className: 'padding-horizontal-4 padding-vertical-2 bg-white' },
                    (offerType === 'FIXED_DISCOUNT' || offerType === 'PERCENTAGE_DISCOUNT') && (react_1.default.createElement("div", { className: 'discount' },
                        react_1.default.createElement("p", null, "Woohoo!"),
                        react_1.default.createElement("img", { src: discountImage, alt: 'Discount image' }),
                        react_1.default.createElement("h4", { className: 'padding-4' }, (function () {
                            var amount = offerType === 'PERCENTAGE_DISCOUNT' ? "".concat(getRetentionOffer.retentionOffer.discount, "%") : "$".concat(getRetentionOffer.retentionOffer.discount);
                            return "We've successfully applied ".concat(amount, " off to your upcoming bundle!");
                        })()),
                        react_1.default.createElement("button", { onClick: handleClose, className: 'cell medium-6 button large wisteria padding-vertical-5' }, "Go to my bundle"))),
                    (offerType === 'AUTO_VARIANTS' || offerType === 'SELECT_VARIANTS') && (react_1.default.createElement("div", { className: 'chosenVariant' },
                        react_1.default.createElement("h3", null, "Woohoo Congrats!"),
                        redeemedVariants.map(function (_a) {
                            var variant = _a.variant;
                            return (react_1.default.createElement("div", { key: variant.id },
                                react_1.default.createElement("img", { src: variant.imgSrc || variant.product.imgSrc, alt: variant.title, className: 'display-block', style: { margin: '0 auto', height: '32vh' } }),
                                react_1.default.createElement("p", null,
                                    react_1.default.createElement("span", { className: 'strong' }, (0, format_bundle_variant_title_1.default)(variant.product.title)),
                                    " has been added to your next ",
                                    selectedBundleType,
                                    " bundle")));
                        }),
                        react_1.default.createElement("button", { onClick: handleClose, className: 'cell medium-6 button large wisteria padding-vertical-5' }, "Go to my account")))))),
            shouldSelectVariants && !redemptionError && (react_1.default.createElement("div", { className: 'selectFreebie' },
                react_1.default.createElement("div", { className: 'bg-wisteria padding-3' },
                    react_1.default.createElement("div", { className: 'retention-integration__header padding-vertical-2' }, getRetentionOffer.retentionOffer.title)),
                react_1.default.createElement("div", { className: 'padding-horizontal-4 padding-vertical-2 bg-white' },
                    react_1.default.createElement("div", { className: 'retention-integration__description padding-vertical-2' },
                        getRetentionOffer.retentionOffer.description,
                        react_1.default.createElement("br", null),
                        react_1.default.createElement("strong", null, (function () {
                            var maxNumVariantsToSelect = getRetentionOffer.retentionOffer.maxNumVariantsToSelect;
                            if (maxNumVariantsToSelect === 1)
                                return 'Select a product:';
                            if (!maxNumVariantsToSelect)
                                return "Select products:";
                            return "Select up to ".concat(maxNumVariantsToSelect, " products:");
                        })())),
                    react_1.default.createElement("div", { className: 'freebieList grid-x' }, getRetentionOffer.retentionOffer.variants.map(function (item) {
                        var variant = item.variant;
                        var selected = selectedVariants.some(function (v) { return v.variant.id === variant.id; });
                        var isOutOfStock = variant.inventory_quantity <= 0;
                        var displayPrice = determinePrice(getRetentionOffer.retentionOffer, item).toFixed(2);
                        // only show the compare at price if the customer is getting a discount
                        var compareAtPrice = variant.compare_at_price || variant.price;
                        var showCompareAtPrice = Number(displayPrice) < Number(compareAtPrice);
                        return (react_1.default.createElement("div", { key: variant.id, className: 'cell text-center retention-app-variant-picker padding-2 medium-4 small-6' },
                            react_1.default.createElement("div", { className: (0, classnames_1.default)('bordered position-relative radius product-pick', selected ? 'selected border-wisteria' : 'border-bonjour'), style: { borderWidth: 3 } },
                                react_1.default.createElement("img", { src: variant.imgSrc || variant.product.imgSrc, alt: variant.product.title, className: (0, classnames_1.default)('display-block', isOutOfStock && 'filter-gray'), style: { cursor: 'pointer' }, onClick: handleSelectVariant(item) }),
                                react_1.default.createElement("a", { className: 'position-absolute bottom-0 right-0 plus-icon flex-container align-middle align-center text-bonjour font-bold', dangerouslySetInnerHTML: { __html: selected ? '<i class="ss-check"></i>' : '+' }, onClick: handleSelectVariant(item) })),
                            react_1.default.createElement("div", { className: 'margin-top-2' },
                                react_1.default.createElement("div", { className: 'text-nobel' }, (0, format_bundle_variant_title_1.default)(variant.product.title)),
                                showCompareAtPrice && react_1.default.createElement("span", { className: 'compare-at-price' }, (0, format_price_1.default)(compareAtPrice)),
                                react_1.default.createElement("span", { className: 'price' }, (0, format_price_1.default)(displayPrice)))));
                    })),
                    react_1.default.createElement("div", { className: 'padding-2 bg-white retention-integration__bottom-button' },
                        react_1.default.createElement("button", { className: (0, classnames_1.default)('text-white width-100 padding-5', isRedeeming || !hasSelectedEnoughVariants ? 'bg-light-wisteria' : 'bg-wisteria'), onClick: function () { return handleRedeem(selectedVariants.map(function (v) { return v.variant.id; })); }, disabled: isRedeeming || !hasSelectedEnoughVariants }, isRedeeming ? 'Redeeming...' : 'Add to bundle'))))))));
};
exports.default = (0, react_router_dom_1.withRouter)(RetentionOfferV2);
